{
  "pages.title": "Sayfalar",
  "pages.description": "Sayfalarını, planlarını ve bağlantılı işlerini bir araya getir.",
  "pages.disabled": "Sayfalar şu anda kapalı. Mevcut çalışma alanlarını kullanabilirsin.",
  "pages.back_planner": "Planlayıcıya dön",
  "pages.tree": "Sayfaların",
  "pages.favorites": "Favoriler",
  "pages.private_pages": "Özel sayfalar",
  "pages.recent": "Son düzenlenen sayfalar",
  "pages.sidebar_empty": "Henüz sayfa yok. + ile ilk sayfanı ekle.",
  "pages.archive_empty": "Arşivlenmiş sayfa yok.",
  "pages.open_sidebar": "Sayfa gezginini aç",
  "pages.close_sidebar": "Sayfa gezginini kapat",
  "pages.from_template": "Şablondan oluştur",
  "pages.remove_favorite": "Favorilerden çıkar",
  "pages.move_to_page": "Başka sayfaya taşı",
  "pages.destination_page": "Hedef sayfa",
  "pages.select_page": "Sayfa seç",
  "pages.new_page": "Yeni sayfa",
  "pages.new_subpage": "Alt sayfa ekle",
  "pages.search_pages": "Sayfa ara…",
  "pages.home": "Giriş sayfası",
  "pages.open_home": "Giriş sayfamı aç",
  "pages.show_archive": "Arşivlenen sayfalar",
  "pages.hide_archive": "Arşivlenenleri gizle",
  "pages.experimental": "Deneysel çalışma alanı",
  "pages.welcome": "Sana göre şekillenen bir alan.",
  "pages.welcome_body": "Bir sayfa aç, serbestçe yaz. / ile gerçek görevlerini, planlarını, projelerini ve araçlarını ekle. Mevcut çalışma alanlarınla aynı veriler üzerinde çalışırsın.",
  "pages.first_page": "İlk sayfanı oluştur",
  "pages.name": "Başlık",
  "pages.untitled": "Başlıksız sayfa",
  "pages.template": "Başlangıç",
  "pages.template.blank": "Boş sayfa",
  "pages.template.project": "Proje ve plan çalışma alanı",
  "pages.template.life": "Yaşam takibi",
  "pages.template.project_heading": "Üzerinde çalıştıklarım",
  "pages.template.life_heading": "Fark etmek istediklerim",
  "pages.create": "Oluştur",
  "pages.move_page": "Sayfayı taşı",
  "pages.parent_page": "Bu sayfanın altına",
  "pages.root": "En üst düzey",
  "pages.move": "Taşı",
  "pages.expand": "Alt sayfaları aç",
  "pages.favorite": "Favori",
  "pages.set_home": "Giriş sayfası yap",
  "pages.archive": "Arşivle",
  "pages.restore": "Geri getir",
  "pages.page_actions": "Sayfa işlemleri",
  "pages.breadcrumb": "Sayfa yolu",
  "pages.source": "Kaynak",
  "pages.visual": "Belge",
  "pages.history": "Geçmiş",
  "pages.duplicate": "Çoğalt",
  "pages.copy_suffix": "(kopya)",
  "pages.recovered_draft": "Bu hesaba ait kaydedilmemiş taslak bulundu. Kaydetmeden önce incele.",
  "pages.keep_draft": "Taslağımı koru",
  "pages.discard_draft": "Taslağı bırak",
  "pages.conflict_detail": "Kaydedilmiş belge veya bağlı kayıt değişti. Taslağın korundu; yeni düzenleme için güncel sürümü yükle.",
  "pages.load_server": "Kayıtlı sürümü yükle",
  "pages.retry": "Yeniden dene",
  "pages.archived_notice": "Bu sayfa arşivlendi.",
  "pages.subtasks": "Alt görevler",
  "pages.add_subtask": "Alt görev ekle",
  "pages.source_hint": "ExoDoc kaynağını düzenle, ardından tek seferde uygula. Kaynağı okumak veya yazmak kayıt işlemi başlatmaz.",
  "pages.source_label": "ExoDoc kaynağı",
  "pages.source_pending": "Belgeye dönmeden önce kaynak taslağını uygula veya bırak.",
  "pages.source_target_mismatch": "Bu kaynak başka bir belgeye veya revizyona ait ya da eksik. Değiştirmeden önce güncel kaynağın tamamını oku.",
  "pages.discard_source": "Kaynak değişikliklerini bırak",
  "pages.apply": "Uygula",
  "pages.backlinks": "Bağlantı veren sayfalar",
  "pages.upload": "Dosya ekle",
  "pages.page_link": "Sayfa bağlantısı",
  "pages.history_hint": "Belge revizyonu içeriği ve yerleşimi geri getirir. Bağlı görev ve diğer kayıtların güncel durumu korunur.",
  "pages.revision_restored": "Belge revizyonu geri getirildi",
  "pages.media_retry": "Belge hazır. Eklemek için dosyayı yeniden seç.",
  "pages.task_trashed": "Görev çöp kutusuna taşındı",
  "pages.task_trash_detail": "Gerçek görev çöp kutusunda. Alt görevlerin kendi durumu korunur.",
  "pages.save_error": "Değişiklikler kaydedilemedi.",
  "pages.load_error": "Bu içerik yüklenemedi.",
  "pages.loading": "Yükleniyor…",
  "pages.saved": "Kaydedildi",
  "pages.dirty": "Kaydedilmemiş değişiklikler",
  "pages.saving": "Kaydediliyor…",
  "pages.offline": "Çevrimdışı · taslak korundu",
  "pages.error": "Kaydedilemedi",
  "pages.conflict": "Değişiklikleri incele",
  "pages.source_draft": "Kaynak taslağı · uygulanmadı",
  "pages.search_more": "Diğer sayfalar için aramayı daralt.",
  "pages.entity_composer": "Bağlantılı kayıt ekle",
  "pages.entity_type": "Kayıt türü",
  "pages.create_new": "Yeni oluştur",
  "pages.link_existing": "Mevcut kaydı bağla",
  "pages.search_entities": "Kayıtlarda ara",
  "pages.no_results": "Sonuç yok",
  "pages.description_field": "Açıklama",
  "pages.note_content": "Not içeriği",
  "pages.start_date": "Başlangıç tarihi",
  "pages.end_date": "Bitiş tarihi",
  "pages.frequency": "Tekrar",
  "pages.daily": "Her gün",
  "pages.weekly": "Her hafta",
  "pages.create_and_insert": "Oluştur ve sayfaya ekle",
  "pages.creation_unavailable": "Bu tür burada bağlanabilir. Oluşturmak için kendi alanına ait işlem gerekir.",
  "pages.subtask_context": "Yeni görev, açık görevin gerçek alt görevi olacak.",
  "pages.plan_context": "Yeni görev bu plana bağlanacak.",
  "pages.project_context": "Yeni görev bu projeye bağlanacak.",
  "pages.paragraph": "Metin",
  "pages.heading1": "Başlık 1",
  "pages.heading2": "Başlık 2",
  "pages.bullet": "Madde listesi",
  "pages.numbered": "Numaralı liste",
  "pages.checklist": "Yerel kontrol listesi",
  "pages.toggle": "Açılır bölüm",
  "pages.toggle_title": "Bölüm başlığı",
  "pages.quote": "Alıntı",
  "pages.divider": "Ayraç",
  "pages.code": "Kod bloğu",
  "pages.table": "İçerik tablosu",
  "pages.columns2": "İki sütun",
  "pages.columns3": "Üç sütun",
  "pages.image": "Görsel",
  "pages.file": "Dosya",
  "pages.focus": "Odak sayacı",
  "pages.editor_placeholder": "Yazmaya başla veya blok eklemek için / yaz…",
  "pages.editor_label": "Sayfa içeriği",
  "pages.formatting": "Metin biçimlendirme",
  "pages.add_block": "Blok ekle",
  "pages.bold": "Kalın",
  "pages.italic": "İtalik",
  "pages.link": "Bağlantı",
  "pages.link_url": "Bağlantı adresi",
  "pages.move_up": "Bloğu yukarı taşı",
  "pages.move_down": "Bloğu aşağı taşı",
  "pages.undo": "Geri al",
  "pages.redo": "Yinele",
  "pages.add_row": "Satır ekle",
  "pages.add_column": "Sütun ekle",
  "pages.close": "Kapat",
  "pages.block_actions": "Blok işlemleri",
  "pages.unlink": "Yalnız bu sayfadan kaldır",
  "pages.trash_task": "Gerçek görevi çöp kutusuna taşı",
  "pages.complete_task": "Görevi tamamla",
  "pages.entity_unavailable": "Bağlı kayıt kullanılamıyor",
  "pages.unknown_block": "Bu blok desteklenmeyen bir sürüm kullanıyor. İçeriği korundu.",
  "pages.view": "Görünüm",
  "pages.view.tasks": "Görevler",
  "pages.view.saved": "Kayıtlı görünüm",
  "pages.view.calendar": "Takvim",
  "pages.view.life": "Yaşam tablosu",
  "pages.view.empty": "Henüz kayıt yok. Bir görev ekle veya görünümü değiştir.",
  "pages.view.configure_life": "Gerçek kayıtları göstermek için bir yaşam tablosu seç.",
  "pages.live_view": "Canlı görünüm · sonuçlar belgeye kopyalanmaz",
  "pages.new_task": "Yeni görev",
  "pages.new_row": "Yeni kayıt",
  "pages.more": "Daha fazla yükle",
  "pages.date": "Tarih",
  "pages.calendar.day": "Gün",
  "pages.calendar.week": "Hafta",
  "pages.calendar.month": "Ay",
  "pages.calendar.year": "Yıl",
  "pages.media_unavailable": "Bu ek önizlenemedi.",
  "pages.download": "İndir",
  "pages.field.description": "Açıklama",
  "pages.details": "Ayrıntılar",
  "pages.field.content": "Asıl not içeriği",
  "pages.field.start_date": "Başlangıç",
  "pages.field.end_date": "Bitiş",
  "pages.field.target_date": "Hedef tarih",
  "pages.field.priority": "Öncelik",
  "pages.field.estimate_minutes": "Tahmin (dakika)",
  "pages.priority.low": "Düşük",
  "pages.priority.normal": "Normal",
  "pages.priority.high": "Yüksek",
  "pages.status.pending": "Bekliyor",
  "pages.status.active": "Etkin",
  "pages.status.completed": "Tamamlandı",
  "pages.status.cancelled": "İptal edildi",
  "pages.status.skipped": "Atlandı",
  "pages.status.trashed": "Çöp kutusunda",
  "pages.status.archived": "Arşivlendi",
  "pages.status.draft": "Taslak",
  "pages.entity.task": "Görev",
  "pages.entity.project": "Proje",
  "pages.entity.plan": "Plan",
  "pages.entity.routine": "Rutin",
  "pages.entity.span": "Dönem",
  "pages.entity.period": "Dönem",
  "pages.entity.note": "Not",
  "pages.entity.life_area": "Yaşam alanı",
  "pages.entity.life_schema": "Yaşam tablosu",
  "pages.entity.life_item": "Yaşam kaydı",
  "pages.entity.knowledge_item": "Bilgi",
  "pages.entity.knowledge_map": "Kavram haritası",
  "pages.entity.goal": "Hedef",
  "pages.entity.decision": "Karar",
  "pages.entity.rationale": "Gerekçe",
  "pages.entity.moment": "Günlük kaydı",
  "pages.entity.work_session": "Çalışma oturumu",
  "pages.entity.focus_session": "Odak oturumu",
  "pages.entity.saved_view": "Kayıtlı görünüm",
  "pages.table_context": "Kayıt seçilen tabloya eklenir.",
  "pages.frequency.daily": "Her gün",
  "pages.frequency.times_per_week": "Haftada belirli sayıda",
  "pages.frequency.every_x_days": "Belirli gün aralığında",
  "pages.frequency_count": "Tekrar sayısı / aralığı",
  "pages.life_section": "Yaşam bölümü",
  "pages.life_section.tracking": "Takip",
  "pages.life_section.guide": "Rehber",
  "pages.select_area": "Yaşam alanını seç",
  "pages.select_table": "Yayımlanmış tabloyu seç",
  "pages.schema_kind": "Tablo türü",
  "pages.schema_kind.record": "Kayıt",
  "pages.schema_kind.entity": "Varlık",
  "pages.schema_kind.guide_entry": "Rehber öğesi",
  "pages.time_mode": "Zaman alanı",
  "pages.time_mode.none": "Yok",
  "pages.time_mode.date": "Tarih",
  "pages.time_mode.instant": "Tarih ve saat",
  "pages.time_mode.interval": "Zaman aralığı",
  "pages.device_timezone": "Saat dilimi: {{zone}} (bu cihaz)",
  "pages.template.preview.blank": "Boş bir metin sayfası oluşturur.",
  "pages.template.preview.project": "Uyguladığınızda gerçek bir proje ve plan oluşturulur; görev görünümü ve odak aracı sayfaya eklenir.",
  "pages.template.preview.life": "Uyguladığınızda gerçek bir Yaşam alanı ve tarihli kayıt tablosu oluşturulur. Henüz kayıt eklenmez.",
  "pages.unsaved_navigation": "Kaydedilmemiş taslağınız var. Sayfadan ayrılsanız da bu hesapta taslak korunur.",
  "pages.stay": "Burada kal",
  "pages.leave": "Taslağı koru ve ayrıl",
  "pages.read_only_entity": "Bu kayıt çöp kutusunda veya salt okunur. İçeriği görüntüleyebilirsiniz.",
  "pages.old_view": "Eski görünümde aç",
  "pages.columns_ratio": "Sütun oranı",
  "pages.command_group.writing": "Yazı blokları",
  "pages.command_group.records": "Gerçek kayıtlar",
  "pages.command_group.media": "Sayfa ve dosyalar",
  "pages.command_group.tools": "Görünümler ve araçlar",
  "pages.link_placeholder": "https://ornek.com",
  "pages.drag_block": "Bloğu sürükleyerek taşı veya Alt + ok tuşlarını kullan"
}
